import { calculateForumScore } from './forumScore';
import type { ForumBase } from '../types/forum';

export function findSimilarForums(
  current: ForumBase,
  all: ForumBase[],
  limit = 5
): ForumBase[] {
  const score = calculateForumScore(
    current.topics_count,
    current.posts_count,
    current.members_count,
    current.founded_year
  );
  return all
    .filter((f) => f.id !== current.id && f.is_active !== false && f.category === current.category)
    .map((f) => {
      const fs = calculateForumScore(f.topics_count, f.posts_count, f.members_count, f.founded_year);
      const sizeDiff = Math.abs(f.members_count - current.members_count);
      const scoreDiff = Math.abs(fs - score);
      const softwareBonus = f.software === current.software ? -500 : 0;
      const distance = sizeDiff + scoreDiff * 2 + softwareBonus;
      return { f, distance };
    })
    .sort((a, b) => a.distance - b.distance)
    .slice(0, limit)
    .map((x) => x.f);
}
